
import API from '@/api/api'

const CartApi = {

  mixins: [API],
  data() {
    return {      
      endpoints: {        
        get_cart_status: {
          type: 'http_get',
          appends: 'mi-carrito/cart-status'
        },
        get_order: {
          type: 'http_get',
          appends: 'mi-carrito/get-order'
        },
        empty_cart: {
          type: 'http_get',
          appends: 'mi-carrito/empty-cart'
        },
        set_order_shipping: {
          type: 'http_post',
          appends: 'mi-carrito/set-order-shipping'
        },
        set_order_shipping_method: {
          type: 'http_post',
          appends: 'mi-carrito/set-order-shipping-method'
        },
        set_order_coupon: {
          type: 'http_post',
          appends: 'mi-carrito/set-order-coupon'
        },
        set_order_data: {
          type: 'http_post',
          appends: 'mi-carrito/set-order-data'
        },
        push_item: {
          type: 'http_post',
          appends: 'mi-carrito/push-item'
        },
        change_item_quantity: {
          type: 'http_update',
          appends: 'mi-carrito/change-item-quantity'
        },
        remove_item: {
          type: 'http_update',
          appends: 'mi-carrito/remove-item'
        },
        remove_coupon: {
          type: 'http_post',
          appends: 'mi-carrito/remove-coupon'
        },
        get_shipping: {
          type: 'delta360',
          appends: 'shipping/get-details'
        },
        get_coupon: {
          type: 'delta360',
          appends: 'salestools/coupons/search'
        },
        place_order: {
          type: 'delta360',
          appends: 'orders/place-order'
        },

        // OrderHolder
        find_holder: {
          type: 'delta360',
          appends: 'holders/public/find'
        },
        
        // Forget Cart
        remove_session: {
          type: 'http_post',
          appends: 'mi-carrito/remove-session'
        },
      }
    }
  },
};

export default CartApi;